import * as React from "react";
import { connect } from "react-redux";
import { IdSoundState } from "../../constants/IdSoundState";
import { IdStyles } from "../../less/IdStyles";
import { ButtonDelete } from "../generic/common/ButtonDelete";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
import { actionPlayerSettingsSetSound } from "../info/player-settings/actionPlayerSettingsInfo";
import { mapSettingsButtonSoundDisplay, } from "./mapSettingsButtonSoundDisplay";
var _SettingsToggleSound = function (_a) {
    var soundGroup = _a.soundGroup, isMuted = _a.isMuted, onClick = _a.onClick;
    var infos = mapSettingsButtonSoundDisplay.get(soundGroup);
    var icon = infos.icon;
    var soundState = isMuted ? IdSoundState.Disabled : IdSoundState.Enabled;
    var localizationKey = infos.locas[soundState];
    var ButtonComponent = isMuted ? ButtonDelete : ButtonPrimary;
    var handleOnClick = function () {
        onClick(soundGroup, !isMuted);
    };
    return (React.createElement(ButtonComponent, { onClick: handleOnClick },
        React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
        React.createElement(FontWithOutline, { style: IdStyles.TextButtonDefault },
            React.createElement(TextLoca, { id: localizationKey }))));
};
var mapState = function (state, ownProps) { return ({
    isMuted: state.playerSettingsInfo.sound[ownProps.soundGroup],
}); };
var mapDispatch = function (dispatch) { return ({
    onClick: function (soundGroupId, enabled) {
        return dispatch(actionPlayerSettingsSetSound(soundGroupId, enabled));
    },
}); };
export var SettingsToggleSound = connect(mapState, mapDispatch)(_SettingsToggleSound);



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/SettingsToggleSound.tsx
// module id = 2752
// module chunks = 3